import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    discs: [],
    myBag: [],
  },
  getters:{
    GetDiscraftDiscs: state => { return state.discs.filter(disc => disc.brand == "Discraft")},
    GetAllDiscs: state => {return state.discs},
    GetNotDiscraft: state => {return state.discs.filter(disc => disc.brand != "Discraft")},
    GetBag: state => {return state.myBag}
  },
  mutations: {
    discs: (state, discs) => {
      state.discs = discs;
    },
  },
  actions: {
    SetDiscsInitial({commit}, discs){
      commit('discs', discs);
    },
    AddToBag({state, getters}, disc){
      const existing = getters.GetBag.findIndex(e => e.id == disc.id);
      if(existing != -1){
        return;
      }
      else{
        state.myBag.push(disc);
      }
    },
    RemoveFromBag({state, getters}, obj){
      const existing = getters.GetBag.findIndex(e => e.id == obj.id);
      if(existing != -1){
        state.myBag.splice(existing, 1);
      }
    }
  },
  modules: {
  }
})
